import { GroupVisit, GroupVisitControllerApi } from "@/services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "@/utils/utils";

type Params = {
  groupVisit: GroupVisit;
};

export const useUpdateGroupVisit = () =>
  useMutationWithLoading(async ({ groupVisit }: Params) =>
    new GroupVisitControllerApi(getConfigObject()).updateGroupVisit(
      groupVisit,
      getXtenantId()
    )
  );
